// extracted by mini-css-extract-plugin
export default {"google":"AuthIcons_google__JvEKh","element":"AuthIcons_element__pN2Cq"};